import { map as lMap } from 'lodash-es';
import { MapRef } from 'react-map-gl';

export function removeAllLayersAndSources(map: MapRef | undefined) {
  map?.getStyle().layers?.forEach((layer) => {
    if (layer.id.includes('bambi-route')) {
      if (map.getMap().getLayer(layer.id)) {
        map.getMap().removeLayer(layer.id);
      }
    }
  });

  const sources = map?.getStyle().sources;
  lMap(sources, (v, k) => {
    if (k.includes('bambi-route')) {
      map?.getMap().removeSource(k);
    }
  });
}
